import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

import {
  BACKGROUND_COLORS,
  BORDER_RADII,
  SPACING,
  TEXT_STYLES,
} from '~/packages/common-frontend/theme/tokens';
import { resolveColor } from '~/packages/common-frontend/theme/utils';

// Exports
export const Tooltip = defineStyleConfig({
  baseStyle: defineStyle((props) => {
    return {
      backgroundColor: resolveColor(props, BACKGROUND_COLORS.black.hover),
      borderRadius: BORDER_RADII.base,
      fontSize: TEXT_STYLES.sm.fontSize,
      gap: SPACING[1],
      lineHeight: TEXT_STYLES.sm.lineHeight,
      paddingBlock: SPACING[2],
      paddingInline: SPACING[4],
    };
  }),
});
